import axios from 'axios'
import { extractError } from '../utils/errorHandler'

/**
 * Lotes em estoque por item, com a última sincronização do estoque.
 * search: código ou descrição do item, ou lote; includeUnavailable: traz também lotes sem saldo.
 */
export const getLots = async (search, includeUnavailable = false) => {
  try {
    const { data } = await axios.get('materialLots', {
      params: { ...(search ? { search } : {}), includeUnavailable },
    })
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}
